import { render, staticRenderFns } from "./quotation-overview-result.vue?vue&type=template&id=28523a0d"
import script from "./quotation-overview-result.vue?vue&type=script&lang=js"
export * from "./quotation-overview-result.vue?vue&type=script&lang=js"
import style0 from "./quotation-overview-result.vue?vue&type=style&index=0&id=28523a0d&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28523a0d')) {
      api.createRecord('28523a0d', component.options)
    } else {
      api.reload('28523a0d', component.options)
    }
    module.hot.accept("./quotation-overview-result.vue?vue&type=template&id=28523a0d", function () {
      api.rerender('28523a0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-overview-result.vue"
export default component.exports